import { Handle, Position, type NodeProps } from '@xyflow/react'
import clsx from 'clsx'

import type { StateMachineNode as StateMachineNodeType } from '../../ProgramStateMachine.types'

import styles from './StateMachineNode.module.scss'

function buildHandles(stateId: string, direction: 'source' | 'target', count: number) {
  if (count === 0) return []

  if (count === 1) return [{ id: `${stateId}-${direction}-0`, left: '50%' }]

  return Array.from({ length: count }, (_, i) => ({
    id: `${stateId}-${direction}-${i}`,
    left: `${((i + 1) / (count + 1)) * 100}%`
  }))
}

export function StateMachineNode({ data, selected }: NodeProps<StateMachineNodeType>) {
  const { stateId, label, isEntryPoint, targetHandleCount, estimatedWidth } = data

  const targetHandles = buildHandles(stateId, 'target', targetHandleCount)

  return (
    <div
      className={clsx(styles.nodeCard, isEntryPoint && styles.entryPoint, selected && styles.selected)}
      style={estimatedWidth ? { width: estimatedWidth } : undefined}
      data-testid={`sm-node-${stateId}`}
    >
      {targetHandles.map(handle => (
        <Handle
          key={handle.id}
          type="target"
          position={Position.Top}
          id={handle.id}
          className={styles.handle}
          style={{ left: handle.left }}
        />
      ))}
      <span className={styles.label}>{label}</span>
      <span className={styles.chevron}>&rsaquo;</span>
      <Handle type="source" position={Position.Bottom} id={`${stateId}-source-0`} className={styles.handle} />
    </div>
  )
}
